import {
  Box,
  Divider,
  Heading,
  HStack,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";
import { resellerGuide, supplierGuide } from "../constants/Guide";
import { RiBuilding3Fill, RiStore2Fill } from "@remixicon/react";
import GuideBook from "../components/guide_page/GuideBook";
import { MetaTag } from "../utils/MetaTag";

const GuidePage = () => {
  const { role } = useParams();

  const borderColor = useColorModeValue("gray.200", "gray.700");
  const hoverBgColor = useColorModeValue("gray.50", "gray.800");

  if (role === "reseller") {
    return (
      <>
        <MetaTag
          title="Panduan Reseller BisnisLink"
          description="Panduan pengguna untuk Reseller di BisnisLink"
        />

        <GuideBook guide={resellerGuide} role="Reseller" />
      </>
    );
  }
  if (role === "supplier") {
    return (
      <>
        <MetaTag
          title="Panduan Supplier BisnisLink"
          description="Panduan pengguna untuk Supplier di BisnisLink"
        />

        <GuideBook guide={supplierGuide} role="Supplier" />
      </>
    );
  }

  return (
    <Stack
      gap={4}
      px={8}
      pt={4}
      pb={12}
      align="center"
      w="100%"
      h="100%"
      fontSize={14}
    >
      <MetaTag
        title="Panduan Pengguna BisnisLink"
        description="Panduan pengguna untuk Reseller dan Supplier di BisnisLink"
      />

      <Stack w="100%" maxW="600px" textAlign="center">
        <Heading as="h2" mt={4} fontSize={14}>
          Panduan Pengguna
        </Heading>
      </Stack>
      <Stack w="100%" maxW="600px" textAlign="justify">
        <Heading as="h1" fontSize={24} mb={4} textAlign="center">
          <Text as="b" color="red.500">
            BisnisLink
          </Text>
          : Panduan untuk Reseller dan Supplier
        </Heading>
        <Divider />
        <Text>
          BisnisLink adalah platform yang mempertemukan antara Pembeli,
          Reseller, dan Supplier. Bagi kalian yang ingin menjadi Reseller atau
          Supplier, kami telah menyediakan panduan yang dapat membantu kalian
          memulai bisnis di BisnisLink.
        </Text>
        <Text as="b">
          Berikut adalah panduan pengguna untuk Reseller dan Supplier di
          BisnisLink:
        </Text>
        <Stack w="full" justify="space-around" py={8}>
          <HStack
            as={Link}
            to="/guide/reseller"
            gap={4}
            p={6}
            border="1px"
            borderColor={borderColor}
            rounded="xl"
            _hover={{ bgColor: hoverBgColor }}
          >
            <Box p={2} bgColor="orange.100" rounded="xl">
              <Icon as={RiStore2Fill} boxSize={10} color="orange.600" />
            </Box>
            <Stack gap={0}>
              <Heading as="h3" fontSize={18}>
                Reseller
              </Heading>
              <Text color="gray.500">
                Pemasar produk yang akan dijual kepada Pembeli
              </Text>
            </Stack>
          </HStack>
          <HStack
            as={Link}
            to="/guide/supplier"
            gap={4}
            p={6}
            border="1px"
            borderColor={borderColor}
            rounded="xl"
            _hover={{ bgColor: hoverBgColor }}
          >
            <Box p={2} bgColor="purple.100" rounded="xl">
              <Icon as={RiBuilding3Fill} boxSize={10} color="purple.600" />
            </Box>
            <Stack gap={0}>
              <Heading as="h3" fontSize={18}>
                Supplier
              </Heading>
              <Text color="gray.500">
                Pemasok produk yang akan dijual oleh Reseller
              </Text>
            </Stack>
          </HStack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default GuidePage;
